const SET_MODULOS = (state, payload) => {
    state.modulos = payload
}

const SET_HAS_ACCESS = (state, payload) => {
    state.hasAnyAccess = payload
}

const SET_MODULO_ATIVO = (state, payload) =>  {
    state.moduloAtivo = payload
}

const CARREGANDO_MODULOS = (state, status) => {
    state.carregandoModulos = status
}

const SET_TROCANDO_MODULO = (state, status) => {
    state.trocandoModulo = status
}

// ─── CRUD admin ──────────────────────────────────────────────────────────────

const BUSCANDO = (state, payload) => {
    state.buscando = payload
}

const LISTAR_MODULOS_ADMIN = (state, payload) => {
    state.items = payload
}

const ATUALIZAR_PAGINACAO = (state, payload) => {
    state.paginacao = payload
}

const INSERIR_MODULO_SELECIONADO = (state, payload) => {
    state.selecionado = payload
}

const INSERIR_LISTA_USUARIOS = (state, payload) => {
    state.usuarios = payload
}

export {
    SET_MODULOS,
    SET_HAS_ACCESS,
    SET_MODULO_ATIVO,
    CARREGANDO_MODULOS,
    SET_TROCANDO_MODULO,
    BUSCANDO,
    LISTAR_MODULOS_ADMIN,
    ATUALIZAR_PAGINACAO,
    INSERIR_MODULO_SELECIONADO,
    INSERIR_LISTA_USUARIOS
}